import { render } from "./FormatDetector.vue?vue&type=template&id=5e3b17fb"
import script from "./FormatDetector.vue?vue&type=script&lang=js"
export * from "./FormatDetector.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__